import { H4, LI, P } from "../../../../AbstractElements";
import { ConferanceWithClient, StaticTimeLineText } from "../../../../Constant";

export const StaticBasicTimeline = () => {
  return (
    <LI className="d-flex mb-3">
      <div className="timeline-dot-primary"></div>
      <div className="w-100 ms-3">
        <P className="d-flex justify-content-between mb-2">
          <span className="date-content light-background">2 Feb 2023</span>
          <span>7:00 AM </span>
        </P>
        <H4>{ConferanceWithClient}<span className="dot-notification"></span></H4>
        <P className="f-light">{StaticTimeLineText}</P>
      </div>
    </LI>
  );
};
